import { Tooltip } from 'antd';
import { isEmpty } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { connect, useDispatch } from 'react-redux';

import { getOpenedTaskId } from '../../../../../redux/general/selectors';
import { addTaskToProjectAction } from '../../../../../redux/tasks/actions';
import ConnectedProjectSelect from '../../task-components/ConnectedProjectSelect';
import { TaskCardProjects } from '../../task-components/TaskCardProjects';
import { getOpenedTaskProjectAndSectionLabelList } from '../../../../../redux/tasks/tasksToProjectsRelation/selectors';
import { isOpenedTaskLoading } from '../../../../../redux/tasks/taskEntities/selectors';

const AddButtonLabel = ({ title, onClick, disabled, showIcon = true, isGuest }) => {
  if (isGuest) {
    return null;
  }

  return (
    <Tooltip title={!disabled && title}>
      <div
        className="flex items-center gap-1.5 px-2 py-0.5 rounded-lg cursor-pointer transition-colors"
        style={{
          background: 'rgba(99,102,241,0.07)',
          color: 'rgba(99,102,241,0.75)',
          border: '1px solid rgba(99,102,241,0.2)',
          fontSize: 12,
          fontWeight: 500,
        }}
        onMouseEnter={e => { e.currentTarget.style.background = 'rgba(99,102,241,0.13)'; e.currentTarget.style.color = '#4f46e5'; }}
        onMouseLeave={e => { e.currentTarget.style.background = 'rgba(99,102,241,0.07)'; e.currentTarget.style.color = 'rgba(99,102,241,0.75)'; }}
        onClick={onClick}
      >
        {showIcon && (
          <svg width="11" height="11" viewBox="0 0 16 16" fill="currentColor">
            <path d="M8 2a1 1 0 0 1 1 1v4h4a1 1 0 1 1 0 2H9v4a1 1 0 1 1-2 0V9H3a1 1 0 1 1 0-2h4V3a1 1 0 0 1 1-1z"/>
          </svg>
        )}
        <span>{title}</span>
      </div>
    </Tooltip>
  );
};

const TaskDetailsProjects = ({ isGuest, isTaskLoading, projectAndSectionLabelList, taskId, workspaceProjects }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  // const projectRef = useRef(null);

  const [projects, setProjects] = useState([]);
  // const [showProjectDropdown, setShowProjectDropdown] = useState(false);

  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (projectRef.current && !projectRef.current.contains(event.target)) {
  //       setShowProjectDropdown(false);
  //     }
  //   };

  //   document.addEventListener('mousedown', handleClickOutside);
  //   return () => {
  //     document.removeEventListener('mousedown', handleClickOutside);
  //   };
  // }, []);

  useEffect(() => {
    setProjects(
      Object.values(projectAndSectionLabelList || {}).filter(
        (prj) => prj?.projectId || prj?._id,
      ),
    );
  }, [projectAndSectionLabelList]);

  // const workspaceProjectsOptions = useMemo(
  //   () =>
  //     workspaceProjects?.filter((project) => {
  //       const selectedProjectsIdList = projects.map(
  //         (prj) => prj?.projectId || prj?._id,
  //       );
  //       return !selectedProjectsIdList.includes(
  //         project?._id || project?.projectId,
  //       );
  //     }),
  //   [projects, workspaceProjects],
  // );

  const onProjectSelect = useCallback(async (project) => {
    dispatch(
      addTaskToProjectAction(taskId, project?._id),
    );
    setProjects((prevProjects) => [
      ...prevProjects,
      {
        projectId: project?._id,
        sectionId: project?.sections?.[0],
      },
    ]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskId])

  return (
    <>
      <div className="w-full mt-4 mb-2">
        <div className="flex flex-row justify-between align-center">
          <div className="text-[11px] font-semibold uppercase tracking-wider" style={{ color: 'rgba(15,15,25,0.35)' }}>
            <FormattedMessage id="PROJECTS" defaultMessage="Projects" />
          </div>
          <div className="mr-4">
            <Tooltip
              title={
                !isTaskLoading && isEmpty(workspaceProjects) &&
                intl.formatMessage({
                  id: 'NO_PROJECTS_YET_CREATE_TO_ADD',
                  defaultMessage: `You don't have any projects yet. Create one to add this task to a project`,
                })
              }
            >
              <div
                style={
                  isEmpty(workspaceProjects)
                  // || isEmpty(workspaceProjectsOptions)
                    ? { opacity: 0.5 }
                    : {}
                }
                // ref={projectRef}
              >
                {/* <Dropdown
                  disabled={isEmpty(workspaceProjectsOptions)}
                  className={`flex items-center space-x-4 py-2.5 mt-1 bg-blue-500 rounded-bl-lg rounded-br-lg border h-8 px-4 shadow-sm`}
                  trigger={['click']}
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  menu={{
                    items: workspaceProjectsOptions
                      ?.map((project) => ({
                        key: project?._id,
                        label: project?.title,
                        onClick: async () => {
                          await dispatch(addTaskToProjectAction(task?._id, project?._id));
                          setProjects((prevProjects) => [
                            ...prevProjects,
                            {
                              projectId: project?._id,
                              sectionId: project?.sections?.[0],
                            },
                          ]);
                          setShowProjectDropdown(false);
                        },
                      })),
                    style: {
                      overflow: 'scroll',
                      maxHeight: '25vh',
                    },
                  }}
                  placement="bottom"
                  arrow={{ pointAtCenter: true }}
                >

                </Dropdown> */}
                <ConnectedProjectSelect
                  currentValue={projects}
                  callback={onProjectSelect}
                >
                  <AddButtonLabel
                    // onClick={() => setShowProjectDropdown(true)}
                    title={intl.formatMessage({
                      id: 'ADD_TO_PROJECTS',
                      defaultMessage: 'Add to Projects',
                    })}
                    disabled={isEmpty(workspaceProjects)}
                    isGuest={isGuest}
                  />
                </ConnectedProjectSelect>
              </div>
            </Tooltip>
          </div>
        </div>
      </div>
      {!isEmpty(projects) && !isEmpty(workspaceProjects) && (
        <div className="w-full mb-4">
          <TaskCardProjects
            projects={projects}
            taskId={taskId}
            setProjects={setProjects}
          />
        </div>
      )}
      {isTaskLoading && isEmpty(projects) && (
        <div className="w-full">
          <TaskCardProjects
            projects={['loading']}
            taskId={taskId}
            setProjects={setProjects}
            isLoading={true}
          />
        </div>
      )}
      {isEmpty(projects) && !isTaskLoading && (
        <div className="text-[12px] mb-3" style={{ color: 'rgba(15,15,25,0.35)' }}>
          <FormattedMessage
            id="NO_TASK_PROJECTS"
            defaultMessage="This task isn't part of any project"
          />
        </div>
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  isGuest: state?.userReducer?.role === 'guest',
  projectAndSectionLabelList: getOpenedTaskProjectAndSectionLabelList(state),
  taskId: getOpenedTaskId(state),
  workspaceProjects: state.projectReducer.myProjects,
  isTaskLoading: isOpenedTaskLoading(state),
});

export default connect(mapStateToProps)(TaskDetailsProjects);
